export type DesktopControls = "keyboard" | "mouse";
export type TouchControls = "dpad" | "freeride";

export interface Settings {
    desktopControls: DesktopControls;
    touchControls: TouchControls;
}

const STORAGE_KEY = "bike-down.settings";

export const DEFAULT_SETTINGS: Settings = {
    desktopControls: "keyboard",
    touchControls: "dpad",
};

const pick = <T extends string>(value: unknown, allowed: T[], fallback: T): T =>
    allowed.includes(value as T) ? (value as T) : fallback;

export function parseSettings(raw: string | null): Settings {
    let stored: Partial<Settings> = {};
    try {
        stored = JSON.parse(raw ?? "{}") ?? {};
    } catch {
        stored = {};
    }
    return {
        desktopControls: pick(stored.desktopControls, ["keyboard", "mouse"], DEFAULT_SETTINGS.desktopControls),
        touchControls: pick(stored.touchControls, ["dpad", "freeride"], DEFAULT_SETTINGS.touchControls),
    };
}

function readStorage(): string | null {
    try {
        return localStorage.getItem(STORAGE_KEY);
    } catch {
        return null;
    }
}

export const settings: Settings = parseSettings(readStorage());

export function saveSettings() {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {
        // Storage can be blocked (private mode, iframe); settings then last for this session only.
    }
}

export function isTouchDevice(): boolean {
    // `?touch` forces touch controls on a desktop browser for testing.
    return new URLSearchParams(location.search).has("touch") || window.matchMedia("(pointer: coarse)").matches;
}
